import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { IncidentsRoutes } from '../../../routes';

export const IncidentsLayout = () => <SwitchRoute routes={IncidentsRoutes} />;
